export default class UseStoreHandler {
  static getAuthStore() {
    const { useAuthStore } = require('@/stores/auth');
    return useAuthStore();
  }

  static getSessionMessageStore() {
    const { useSessionMessageStore } = require('@/stores/sessionMessage');
    return useSessionMessageStore();
  }

  static getContextStore() {
    const { useContextStore } = require('@/stores/context');
    return useContextStore();
  }

  static getStoreContext() {
    const { useStorageStore } = require('@/stores/storage');
    return useStorageStore();
  }
}
